<template>
  <NoteForm :note="note" :onSubmit="submit"></NoteForm>
</template>

<script>
import NoteForm from './Note-Form.vue';
import { busEvent } from '../../main';

export default {
  name: 'CreateNote',
  components: {
    NoteForm,
  },
  data: () => ({
    note: {
      date: '',
      message: '',
    },
  }),
  methods: {
    submit() {
      this.$store.dispatch('notes/createNote', {
        clientId: this.$route.params.clientId,
        body: this.note,
      })
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Nota a fost creata');
          this.$router.push({ path: `/clients/${this.$route.params.clientId}/notes/` });
        });
    },
  },
};
</script>
